export default {
  meta: {
    title: '计划调整',
    // url: '/fishtogether', // 埋点用，记录所属模块
  }
};
